/**
 * @generated SignedSource<<0024e0b624a4abe2d93b5e2e99639c92>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type breadcrumbsElementFragment$data = {
  readonly items: ReadonlyArray<{
    readonly name: string;
    readonly relativeUrl: string;
  }> | null;
  readonly " $fragmentType": "breadcrumbsElementFragment";
};
export type breadcrumbsElementFragment$key = {
  readonly " $data"?: breadcrumbsElementFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"breadcrumbsElementFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "breadcrumbsElementFragment",
  "selections": [
    {
      "concreteType": "HelpLayoutBreadcrumb",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "relativeUrl"
        },
        {
          "kind": "ScalarField",
          "name": "name"
        }
      ]
    }
  ],
  "type": "HelpLayoutBreadcrumbElement"
};

(node as any).hash = "c3b0af395770d446c29e894f11d5e0e4";

export default node;
